'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgDown(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M9.317 11.615l-.093.092a1.317 1.317 0 01-1.76-.094L2.777 6.905a1.279 1.279 0 010-1.812L7.464.385A1.31 1.31 0 019.22.295l.004-.004.093.092-.005.005c.412.506.38 1.242-.085 1.71l-3.884 3.9L9.227 9.9c.452.454.495 1.162.08 1.706l.01.009z", id: "Down_svg__a" })),
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("g", { transform: "translate(2 2)" },
                React__default.default.createElement("path", { d: "M0 0h12v12H0z" }),
                React__default.default.createElement("use", { fill: "currentColor", transform: "rotate(-90 6 6)", xlinkHref: "#Down_svg__a" })))));
}

module.exports = SvgDown;
//# sourceMappingURL=Down.js.map
